import { render, staticRenderFns } from "./bottom-navigation-item.vue?vue&type=template&id=cd06f3a8&"
import script from "./bottom-navigation-item.vue?vue&type=script&lang=js&"
export * from "./bottom-navigation-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports